document.querySelectorAll('.u-fade-in').forEach(element => {
    ScrollTrigger.create({
        trigger: element,
        start: 'top 85%',
        onEnter: () => element.classList.add('is-show'),
      });
});
